export const isValidMobile = (mobile) => {
  const cleaned = mobile.replace(/\D/g, '');

  return /^0?9\d{9}$/.test(cleaned);
};

export default isValidMobile;
